import {HttpResponse} from "@angular/common/http";
import {FormGroup} from "@angular/forms";

const convertToCSV = (objArray: any[]): string => {
    const array = [Object.keys(objArray[0])].concat(objArray);
    return array.map(it => {
      return Object.values(it).toString();
    }).join('\n');
  }

 export const exportToExcel = function(data: any, fileName: string) {
    const csvData = convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  export const validateAllFormFields = function (formGroup: FormGroup) {   
    Object.keys(formGroup.controls).forEach(field => {  
      const control = formGroup.get(field);             
      if (control instanceof FormGroup) {        
        validateAllFormFields(control);            
      } else {                                      
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

export const getFileNameFromResponse = (response: HttpResponse<any>): string => {
  const contentDisposition = response.headers.get('Content-Disposition');

  if (!contentDisposition) {
      throw new Error('Download response is missing Content-Disposition header.');
  }

  // Handle both filename="..." and filename*=UTF-8''... formats
  let fileName = '';
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);

    if (matches != null && matches[1]) {
    fileName = matches[1].replace(/['"]/g, '');

        // Handle UTF-8 encoded filenames (filename*=UTF-8''...)
    if (fileName.startsWith("UTF-8''")) {
      fileName = decodeURIComponent(fileName.substring(7));
    }
  }

    if (!fileName) {
        throw new Error('Download response Content-Disposition header does not include a filename.');
    }

    return fileName;
}


export const getKeyByValue = function(obj:any, value: string| undefined) {
  return Object.keys(obj).find(key =>
      obj[key] === value);
}

export const getValueByKey = function(obj:any, key: number) {
  return Object.values(obj).find(value =>
      obj[key] === value);
}


// Compare initial values with current values to get only changed fields using json request
export const getUpdatedFieldsJsonReq = function(form:FormGroup, fieldMapping: any) {
  // const formData = new FormData();
  const currentValues = form.value;
  const updatedData: any = {};

  Object.keys(form.controls).forEach((key) => {
    // Check if field is dirty OR if it's city/state and pincode is dirty
    if (form.get(key)?.dirty) {
      const apiFieldName = fieldMapping[key];
      // formData.append(apiFieldName, currentValues[key]);
      updatedData[apiFieldName] = currentValues[key];
      if (key === 'role'){
        updatedData[apiFieldName] = [currentValues[key]];
      }
      
    }
  });

  return updatedData;
}


export const getUpdatedFieldsFormData = function(form:FormGroup, fieldMapping: any) {
  const formData = new FormData();
  const currentValues = form.value;
  Object.keys(form.controls).forEach((key) => {
    if (form.get(key)?.dirty) {
      const apiFieldName = fieldMapping[key];
      formData.append(apiFieldName, currentValues[key]);
     
    }
  });

  return formData;
}

const ORGANIZATION_LEGAL_SUFFIXES = new Set([
    'LLP',
    'LLC',
    'PLLC',
    'LP',
    'LTD',
    'INC',
    'CORP',
]);

const formatOrganizationWord = (word: string): string => {
    const lettersOnly = word.replace(/[^A-Za-z]/g, '');
    if (!lettersOnly) {
        return word;
    }

    const upperLetters = lettersOnly.toUpperCase();
    if (ORGANIZATION_LEGAL_SUFFIXES.has(upperLetters)) {
        return upperLetters;
    }

    const isFullyUppercaseInput = lettersOnly === upperLetters;
    if (isFullyUppercaseInput && isPreservedAcronym(upperLetters)) {
        return upperLetters;
    }

    return upperLetters.charAt(0) + upperLetters.slice(1).toLowerCase();
};

const isPreservedAcronym = (upperLetters: string): boolean => {
    return upperLetters.length >= 2 && upperLetters.length <= 3;
};

export const formatOrganizationName = function (name: string): string {
    if (!name) {
        return name;
    }
    return name
        .trim()
        .split(/\s+/)
        .map((word) => formatOrganizationWord(word))
        .join(' ');
};